import { getProductBrand, getProductBrandLink } from 'utils/productCollectionUtils';
import {
  item,
  item_name,
  item_value,
  meta,
  meta_table
} from './meta.module.scss';

import Link from 'next/link';
import isEmpty from 'utils/isEmpty';

export default function ProductMeta({ product }) {
  const notes = (noteLevel) =>
    product.productPerfumeNotes.nodes.filter(
      (item) =>
        product?.productPerfumeDetail?.[noteLevel].indexOf(item.id.toString()) >
        -1
    );

  const getNoteString = (notes) => {
    let noteNames = [];
    notes.forEach((note) => {
      noteNames.push(note.name);
    });
    return noteNames.join(', ');
  };

  const productBrand = getProductBrand(product.productBrands);

  const details = () => {
    let result = [];
    if (productBrand) {
      result.push({ name: 'Thương hiệu', value: productBrand.name, link: getProductBrandLink(productBrand) });
    }
    if (getNoteString(notes('headnotes')) !== '') {
      result.push({
        name: isEmpty(getNoteString(notes('heartnotes'))) && isEmpty(getNoteString(notes('basenotes'))) ? 'Hương đặc trưng' : 'Hương đầu',
        value: getNoteString(notes('headnotes'))
      });
    }
    if (getNoteString(notes('heartnotes')) !== '') {
      result.push({
        name: 'Hương giữa',
        value: getNoteString(notes('heartnotes'))
      });
    }
    if (getNoteString(notes('basenotes')) !== '') {
      result.push({
        name: 'Hương cuối',
        value: getNoteString(notes('basenotes'))
      });
    }

    return result;
  };

  return details().length > 0 ? (
    <div className={meta}>
      <div className={meta_table}>
        {details().map((item, index) => (
          <MetaItem key={index} name={item.name} value={item.value} link={item?.link} />
        ))}
      </div>
    </div>
  ) : (
    ''
  );
}

const MetaItem = ({ name, value, link = null }) =>
  value ? (
    <div className={item}>
      <span className={item_name}>{name}</span>
      {link != null ?
        <Link href={link}>
          <a>
            <span className={item_value}>{value}</span>
          </a>
        </Link>
        :
        <span className={item_value}>{value}</span>
      }

    </div>
  ) : (
    ''
  );
